import Authenticated from "@/Layouts/Authenticated";
import { useForm, usePage } from "@inertiajs/inertia-react";
import Label from "@/Components/Label";
import LoadingButton from "@/Components/LoadingButton";
import { Inertia } from "@inertiajs/inertia";
import PageHeading from "@/Components/PageHeading";
import React from "react";
import TextInput from "@/Components/TextInput";

const Create = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Group", route: route("groups") },
        { name: "Create", route: null },
    ];

    const { group } = usePage().props;

    const {
        data,
        setData,
        put,
        errors,
        delete: destroy,
        processing,
    } = useForm({
        name: group.name || "",
    });

    function handleSubmit(e) {
        e.preventDefault();
        put(route("groups.update", group.id));
    }

    function handleCancel(e) {
        e.preventDefault();
        Inertia.visit(route("groups"));
    }

    function handleDelete(e) {
        e.preventDefault();
        destroy(route("groups.delete", group.id), {
            onBefore: () => confirm("Are you sure you want to delete?"),
        });
    }

    return (
        <div className="py-6">
            <PageHeading heading={"Create Group"} breadcrumb={breadcrumb} />
            <div className="mt8">
                <div className="mx-auto max-w-lg px-4 py-10 pb-12 lg:pb-16">
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <Label name={"name"} label={"Group Name"} />
                                <TextInput
                                    id={"name"}
                                    name={"name"}
                                    onChange={(e) =>
                                        setData("name", e.target.value)
                                    }
                                    errors={errors.name}
                                    value={data.name}
                                />
                            </div>
                        </div>
                        <div className="pt-5">
                            <div className="flex justify-between">
                                <div>
                                    <LoadingButton
                                        type={"button"}
                                        loading={processing}
                                        className={"btn-danger"}
                                        onClick={handleDelete}
                                    >
                                        Delete
                                    </LoadingButton>
                                </div>
                                <div className="flex justify-end space-x-1">
                                    <LoadingButton
                                        type={"button"}
                                        onClick={handleCancel}
                                        loading={processing}
                                        className="btn-secondary"
                                    >
                                        Cancel
                                    </LoadingButton>
                                    <LoadingButton
                                        type={"submit"}
                                        loading={processing}
                                        className={"btn-primary"}
                                    >
                                        Update
                                    </LoadingButton>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

Create.layout = (page) => (
    <Authenticated title={"Groups"}>{page}</Authenticated>
);

export default Create;
